import React, { useState, useMemo, useCallback } from "react";
import styled from "styled-components";
import { useEpisodes } from "../../hooks/useEpisodes";
import { useChapters } from "../../hooks/useChapters";
import { useLessons } from "../../hooks/useLessons";
import ListTitles from "../ListTitles";
import { ReactComponent as ArrowBack } from "../../assets/svg/arrow-back.svg";
import { useCourses } from "../../hooks/useCourses";
import Courses from "../Courses";
import LessonViewMiddleware from "./LessonViewMiddleware";
import Tree from "../Tree";

const UserTree = ({
  userId = undefined,
  userName,
  userLastname,
  courseId: _courseId,
  episodeId: _episodeId,
  chapterId: _chapterId,
  lessonId: _lessonId,
}) => {
  return <Tree payload={{
    userId: userId,
    userName: userName,
    userLastname: userLastname,
    courseId: _courseId,
    episodeId: _episodeId,
    chapterId: _chapterId,
    lessonId: _lessonId
  }} />
};


const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #32b0ea;
  padding: 20px 15px;
  box-sizing: border-box;
`;

const Container = styled.div`
  max-width: 450px;
  width: 100%;
`;

const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 5px 0px;
  margin-bottom: 25px;
  cursor: pointer;
`;

const Back = styled.div`
  fill: white;
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  margin-right: 15px;
`;

const Title = styled.div`
  font-size: 1.5em;
  font-weight: 600;
  color: white;
`;

const Spinner = styled.img`
  margin: auto;
  width: 25px;
  height: 25px;
  display: block;
`;

const Tag = styled.div`
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 10px 10px;
  margin-bottom: 10px;
  font-size: 0.9em;
  font-weight: 600;
  margin: 0px 0px 25px 0px;
`;

export default UserTree;
